import { Loader, Modal } from "@trackman/web-shared-components";
import AppImagePreview from "components/ui/AppImagePreview";
import { useStores } from "index";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
    userDiagnosticsId: string | null,
};

const UserDiagnosticsImagePreviewModal = observer(({ userDiagnosticsId }: Props) => {
    const [imageUrl, setImageUrl] = useState<string | null>(null);
    const { userDiagnosticStore } = useStores();
    const { t } = useTranslation();

    useEffect(() => {
        console.log(`userDiagnosticStore.selectedBlob ${userDiagnosticStore.selectedFileEntry}`)
        if (userDiagnosticStore.selectedFileEntry?.blob) {
            const url = URL.createObjectURL(userDiagnosticStore.selectedFileEntry.blob);
            setImageUrl(url)
        }
        else if (userDiagnosticStore.selectedFileEntry?.fileName) {
            userDiagnosticStore.downloadUserDiagnosticsFile(userDiagnosticsId ?? null, { specificFileUrl: userDiagnosticStore.selectedFileEntry?.fileName }, false)
        }
    }, [userDiagnosticStore.selectedFileEntry]);

    const renderModalContent = () => {
        if (imageUrl) {
            return <AppImagePreview fileName={userDiagnosticStore.selectedFileEntry?.fileName} srcUrl={imageUrl} />
        }
        else if (userDiagnosticStore.isDownloadingUserDiagnosticsFile) {
            return <Loader />
        }
        else {
            return <p>{t('occurred')}</p>
        }
    };

    return (
        <Modal
            title={userDiagnosticStore.selectedFileEntry?.fileName}
            open={userDiagnosticStore.selectedFileEntry !== undefined && userDiagnosticStore.selectedFileEntry !== null}
            onClose={() => { userDiagnosticStore.setSelectedFileEntry(null) }}
            style={{ zIndex: 2000 }}
        >
            <div className="d-flex align-items-center w-100">
                {renderModalContent()}
            </div>
        </Modal>
    );
});

export default UserDiagnosticsImagePreviewModal;